import Container from '../container/Container';
import { TextLabelSmall } from '../text/Texts';
import styles from './custom-badge.module.css';

type Props = {
	text: string;
};

const CustomBadge = ({ text }: Props) => {
	return (
		<Container className={styles.travelProgramBadge}>
			<TextLabelSmall text={text} className="text-accent60" />
		</Container>
	);
};

export default CustomBadge;
